/**
 * Created by denis.gusarov on 4/27/2017.
 */

namespace Factive.Game {
    import Tween = Factive.Core.Tween.Tween;
    import Easing = Factive.Core.Tween.Easing;

    export class WoodenPanelCubeResultView extends ViewBase {

        public $model: DiceModel;

        public constructor(private _options,
                           private _gameData: GameDataModel) {
            super();
        }

        public static factory: any = {
            get (opt, gameData): WoodenPanelCubeResultView {
                return new WoodenPanelCubeResultView(opt, gameData);
            },
            dependency: ["Options","GameData"]
        };

        public getConfiguration(): IViewConfiguration {
            return <IViewConfiguration>{
                armatureName: "WoodenPanelCubeResul",
                sprites: {
                    cube: "armature(cube)"
                },
                spritesEvents: {
                    "touchstart $sprites.cube": "_onMouseOver",
                    "tap $sprites.cube": "_onMouseClickOrTap",
                    "touchendoutside $sprites.cube": "_onMouseOut",
                    "mouseover $sprites.cube": "_onMouseOver",
                    "mouseout $sprites.cube": "_onMouseOut",
                    "click $sprites.cube": "_onMouseClickOrTap"
                },
                modelWatch:{
                    "value": (newVal, oldVal) => {
                        if(newVal == 0){
                            this.armature.display.visible = false;
                        } else {
                            let tempNames:Array<string> = ["One","Two","Three","Four","Five","Six"];
                            let tempName:string = "RedPoints"+tempNames[newVal-1];
                            var armature = dragonBones.PixiFactory.factory.buildArmature(tempName);
                            this.armature.getSlot("value").display = armature.display;
                            //this.armature.display.visible = true;
                        }
                    },
                    "interactive": (newVal, oldVal) => {
                        this.$sprites.get("cube").interactive = newVal;
                    },
                    "visible": (newVal, oldVal) => {
                        this.armature.display.visible = newVal;
                    }
                }
            };
        }

        protected onContentLoaded(){
        }

        protected onSetLandscape(){
        }

        protected onSetPortrait(){
        }

        public onInitialize(): void {
            this.armature.display.visible = false;
            this.$sprites.get("cube").interactive = this.$model.interactive;
        }

        private _onMouseOver(event: PIXI.interaction.InteractionEvent): void {
        }

        private _onMouseOut(event: PIXI.interaction.InteractionEvent): void {
        }

        private _onMouseClickOrTap(event: PIXI.interaction.InteractionEvent): void {
            this._gameData.selectDice(this.$model);
        }
    }

}


// WEBPACK FOOTER //
// src/typescript/Game/Views/Game/WoodenPanelCubeResultView.ts